import React from "react";

export const IconCameraSmall = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.1367" cy="10" r="9.5" fill="#F3F3F3" stroke="white" />
      <path
        d="M7.9528 14.1693H12.3195C13.4695 14.1693 13.9278 13.4651 13.982 12.6068L14.1986 9.1651C14.257 8.2651 13.5403 7.5026 12.6361 7.5026C12.382 7.5026 12.1486 7.35677 12.032 7.13177L11.732 6.5276C11.5403 6.14844 11.0403 5.83594 10.6153 5.83594H9.66114C9.23197 5.83594 8.73197 6.14844 8.5403 6.5276L8.2403 7.13177C8.12364 7.35677 7.8903 7.5026 7.63614 7.5026C6.73197 7.5026 6.0153 8.2651 6.07364 9.1651L6.2903 12.6068C6.3403 13.4651 6.8028 14.1693 7.9528 14.1693Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.51172 8.33594H10.7617" stroke="#666666" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.1354 12.4974C10.8812 12.4974 11.4896 11.8891 11.4896 11.1432C11.4896 10.3974 10.8812 9.78906 10.1354 9.78906C9.38958 9.78906 8.78125 10.3974 8.78125 11.1432C8.78125 11.8891 9.38958 12.4974 10.1354 12.4974Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconCameraAccount24 = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11.5" fill="#EAECF0" stroke="white" />
      <path
        d="M8.72218 18.25H15.2722C16.9972 18.25 17.6847 17.1937 17.7659 15.9062L18.0909 10.7437C18.1784 9.39375 17.1034 8.25 15.7472 8.25C15.3659 8.25 15.0159 8.03125 14.8409 7.69375L14.3909 6.7875C14.1034 6.21875 13.3534 5.75 12.7159 5.75H11.2847C10.6409 5.75 9.89092 6.21875 9.60342 6.7875L9.15342 7.69375C8.97842 8.03125 8.62843 8.25 8.24718 8.25C6.89093 8.25 5.81593 9.39375 5.90343 10.7437L6.22843 15.9062C6.30343 17.1937 6.99718 18.25 8.72218 18.25Z"
        stroke="#98A2B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.0625 9.5H12.9375" stroke="#98A2B3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 15.75C13.1187 15.75 14.0312 14.8375 14.0312 13.7188C14.0312 12.6 13.1187 11.6875 12 11.6875C10.8813 11.6875 9.96875 12.6 9.96875 13.7188C9.96875 14.8375 10.8813 15.75 12 15.75Z"
        stroke="#98A2B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const IconCameraAccount = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15.5" fill="#F3F3F3" stroke="white" />
      <path
        d="M11.6322 24.3385H20.3655C22.6655 24.3385 23.5822 22.9302 23.6905 21.2135L24.1238 14.3302C24.2405 12.5302 22.8072 11.0052 20.9988 11.0052C20.4905 11.0052 20.0238 10.7135 19.7905 10.2635L19.1905 9.05521C18.8072 8.29688 17.8072 7.67188 16.9572 7.67188H15.0488C14.1905 7.67188 13.1905 8.29688 12.8072 9.05521L12.2072 10.2635C11.9738 10.7135 11.5072 11.0052 10.9988 11.0052C9.1905 11.0052 7.75717 12.5302 7.87384 14.3302L8.30717 21.2135C8.40717 22.9302 9.33217 24.3385 11.6322 24.3385Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.75 12.6719H17.25" stroke="#666666" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15.9974 20.9948C17.4891 20.9948 18.7057 19.7781 18.7057 18.2865C18.7057 16.7948 17.4891 15.5781 15.9974 15.5781C14.5057 15.5781 13.2891 16.7948 13.2891 18.2865C13.2891 19.7781 14.5057 20.9948 15.9974 20.9948Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconCameraAccount;
